/*
 * @Author: your name
 * @Date: 2020-05-07 08:57:54
 * @LastEditTime: 2020-07-07 15:10:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \HNQX_YWNWc:\Users\admin\Desktop\产品库\src\main.js
 */ 
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui' // ui框架
import 'element-ui/lib/theme-chalk/index.css'
import $ from 'jquery'
import echarts from 'echarts'
import { get, post,postToken } from './api/axios'
import * as filters from './api/filter'
import 'babel-polyfill'
// 

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */

// 遍历所有导出的过滤器并添加到全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.$base= require('js-base64').Base64; //全局引用base64
Vue.prototype.$post = post // 方法注册到vue的原型对象，直接通过this.$get,this.$post发送请求
Vue.prototype.$get = get
Vue.prototype.$postToken = postToken

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js